export default __webpack_public_path__ + "static/media/IRANSansWeb_UltraLight.6f6cd663.woff";